import { useTranslation } from "react-i18next";
import {
  FileText,
  MagnifyingGlass,
  Rocket,
  Lightning,
} from "@phosphor-icons/react";

export const HowItWorks = () => {
  const { t } = useTranslation();

  const steps = [
    {
      icon: FileText,
      label: t("how.step1_label"),
      title: t("how.step1_title"),
      desc: t("how.step1_desc"),
    },
    {
      icon: MagnifyingGlass,
      label: t("how.step2_label"),
      title: t("how.step2_title"),
      desc: t("how.step2_desc"),
    },
    {
      icon: Rocket,
      label: t("how.step3_label"),
      title: t("how.step3_title"),
      desc: t("how.step3_desc"),
    },
    {
      icon: Lightning,
      label: t("how.step4_label"),
      title: t("how.step4_title"),
      desc: t("how.step4_desc"),
    },
  ];

  return (
    <section
      data-testid="how-it-works-timeline"
      className="py-24 md:py-32 bg-slate-50 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
            {t("how.overline")}
          </p>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl font-bold tracking-tight text-slate-900 leading-[1.05]">
            {t("how.title")}
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-slate-600">
            {t("how.subtitle")}
          </p>
        </div>

        <div className="mt-20 relative">
          {/* Connector line (desktop) */}
          <div className="hidden lg:block absolute left-0 right-0 top-7 h-px bg-gradient-to-r from-transparent via-slate-300 to-transparent" />

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {steps.map((s, i) => {
              const Icon = s.icon;
              return (
                <div
                  key={i}
                  data-testid={`how-step-${i + 1}`}
                  className="relative"
                >
                  {/* Numbered node */}
                  <div className="relative z-10 inline-flex h-14 w-14 items-center justify-center rounded-full bg-white border border-slate-200 shadow-sm">
                    <Icon size={22} weight="light" className="text-slate-900" />
                  </div>

                  <p className="mt-6 text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
                    {s.label}
                  </p>
                  <h3 className="mt-2 font-heading text-2xl font-bold tracking-tight text-slate-900">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-600">
                    {s.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
